var exports = {
  "Kk": "xfd349460--80002a--icon",
  "NX": "xfd349460--80002a--icon--opened",
  "x6": "xfd349460--80002a--button",
};

module.exports = exports;
